import { Box, Flex, Grid, Text } from "@radix-ui/themes";
import { Dot } from "@/components/logo/Dot";

export const Qualifications = () => {
  return (
    <Flex
      direction={"column"}
      justify={"start"}
      align={"center"}
      gap={"6"}
      className={"mt-32 w-full md:max-w-[768px]"}
    >
      <Flex direction={"column"} justify={"start"} align={"center"} gap={"1"}>
        <Text
          size={"3"}
          weight={"medium"}
          style={{
            color: "var(--tomato-9)",
            fontWeight: "600",
          }}
        >
          교육 및 자격증
        </Text>
      </Flex>
      <Flex justify={"center"} wrap={"wrap"} gap={"6"} className={"w-full"}>
        {qualifications.map((item) => (
          <QualificationItem key={item.title} {...item} />
        ))}
      </Flex>
    </Flex>
  );
};

type Qualification = {
  period: string;
  title: string;
  description: string;
  details: string[];
};

const qualifications: Qualification[] = [
  {
    period: "2021.05.17 ~ 2021.11.10",
    title: "구디아카데미",
    description:
      "공공데이터 융합 자바/스프링 개발자 양성과정(2) (898시간/113일)",
    details: [
      "프론트엔드 — HTML, CSS, JavaScript, JQuery, JSP",
      "데이터베이스 — Oracle DB, SQL",
      "백엔드 — Java, Spring Framework, MyBatis",
      "Spring 기반 웹 개발, 관계형 데이터베이스 설계, 화면 설계 및 디자인, 기능정의서 · 메타데이터 작성",
    ],
  },
  {
    period: "2017.03 ~ 2021.08",
    title: "홍익대학교",
    description: "목조형가구학과 전공",
    details: [
      "졸업 전시 — 위상 수학(topology)과 모아레(moire) 현상으로부터 관계에 대한 고찰을 형태로 풀어냈습니다.",
      "오프라인 전시가 예정되어 있었으나 코로나19로 인해 온라인 전시로 대체되었습니다.",
      "http://www.hongikwfd.com/bbs/board.php?bo_table=c01&wr_id=28&page=2 (*현재 호스팅이 만료되었습니다.)",
    ],
  },
  {
    period: "2021.11.26",
    title: "정보처리기사 — 최종합격",
    description: "한국산업인력공단",
    details: [],
  },
  {
    period: "2021.10.01",
    title: "SQL 개발자(SQLD) — 최종합격",
    description: "한국데이터산업진흥원",
    details: [],
  },
];

const QualificationItem = ({
  period,
  title,
  description,
  details,
}: Qualification) => {
  return (
    <Grid
      gap={"1"}
      className={
        "w-full max-w-[768px] md:grid-cols-3 md:gap-x-10 md:items-start"
      }
    >
      <Flex
        justify={"start"}
        align={"center"}
        gap={"2"}
        className={"w-52 md:justify-self-end z-10"}
      >
        <Flex
          justify={"center"}
          align={"center"}
          className={"w-[18px] h-[36px]"}
        >
          <Box className={"scale-50"}>
            <Dot color={"var(--sand-6)"} />
          </Box>
        </Flex>
        <Text size={"3"} color={"gray"}>
          {period}
        </Text>
      </Flex>
      <Flex
        direction={"column"}
        gap={"1"}
        className={"pl-6 md:pl-0 md:col-span-2"}
      >
        <Flex direction={"column"}>
          <Text size={"4"} style={{ fontWeight: 600, lineHeight: 1.8 }}>
            {title}
          </Text>
          <Text size={"3"} color={"gray"}>
            {description}
          </Text>
        </Flex>
        <Flex direction={"column"} gap={"2"}>
          <Box>
            <ul className={"work-detail-ul rt-r-size-3"}>
              {details.map((detail, index) => (
                <li key={index} className={"rt-r-size-3"}>
                  <Text size={"2"} weight={"medium"}>
                    {detail}
                  </Text>
                </li>
              ))}
            </ul>
          </Box>
        </Flex>
      </Flex>
    </Grid>
  );
};
